import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface BreadcrumbItem {
  label: string
  to?: string
  /** Percorso del segmento, solo per trovare la voce di menu e tradurla (non rende il segmento cliccabile). */
  path?: string
}

export const useBreadcrumbStore = defineStore('breadcrumb', () => {
  const items = ref<BreadcrumbItem[] | null>(null)

  function set(crumbs: BreadcrumbItem[]) {
    items.value = crumbs
  }

  function clear() {
    items.value = null
  }

  return { items, set, clear }
})
